


































































import Vue from 'vue';
import axios, { AxiosResponse, AxiosError } from 'axios';
import NotifyMeForm from './components/NotifyMeForm.vue';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import CookieConsent from './components/CookieConsent.vue';

interface SubscribeResponse {
  success: boolean;
}

export default Vue.extend({
  name: 'App',
  components: {
    Header,
    Footer,
    NotifyMeForm,
    CookieConsent,
  },
  data() {
    return {
      subscribed: false,
      loading: false,
      errors: {} as { [key in string]: string[] },
    };
  },
  methods: {
    notify(email: string): void {
      this.loading = true;
      axios.request({
        url: `${process.env.VUE_APP_API_URL}/subscribe`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'post',
        data: { email },
      }).then((response: AxiosResponse<SubscribeResponse>) => {
        if (response.data.success) {
          this.subscribed = true;
        }
      }).catch((error: AxiosError<{ [key in string]: string[] }>) => {
        this.errors = error.response?.data
          ?? {
            errors: ['We can\'t go on with your subscription right now. Please, try again later.'],
          };
      }).finally(() => {
        this.loading = false;
      });
    },
  },
});
